<template>
  <!-- 新增添加角色页面 -->
  <div>
    <div class="jueSe">
      <p>新增角色</p>
    </div>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      label-width="120px"
      :rules="rules"
    >
      <el-form-item label="角色名" prop="roleName">
        <el-input
          v-model="ruleForm.roleName"
          placeholder="请输入角色名"
          style="width: 600px"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="roleComments">
        <el-input
          v-model="ruleForm.roleComments"
          placeholder="备注"
          style="width: 600px"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色是否可用">
        <el-radio-group v-model="ruleForm.del">
          <el-radio :label="0">可用</el-radio>
          <el-radio :label="1">不可用</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="textAnnotation">
        <p>
          拥有权限<span
            >(注：选择子菜单，必须把父级菜单、祖级菜单勾选，取消菜单同理)</span
          >
        </p>
      </div>
      <el-form-item label="">
        <el-tree
          :data="data"
          show-checkbox
          :default-expand-all="true"
          :expand-on-click-node="false"
          check-on-click-node
          ref="tree"
          :props="defaultProps"
          @check="handleNodeClick"
        >
        </el-tree>
      </el-form-item>
      <el-form-item label="">
        <div>
          <el-button type="primary" @click="goAddAdmin">提交</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 多选框的名称
      data: [],
      defaultProps: {
        children: "children",
        label: "acitonName",
      },
      ruleForm: {
        roleName: "", // 用户名
        roleComments: "", //备注
        del: 0,
        actions: [],
      },
      actions: [],
      //   验证规则
      rules: {
        roleName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        roleComments: [
          { required: true, message: "请输入备注", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.ruleForm.createBy = JSON.parse(
      window.sessionStorage.getItem("admin")
    ).adminId;
    this.getData();
  },
  mounted() {},
  methods: {
    goAddAdmin() {
      let list = this.$refs.tree.getCheckedNodes({
        leafOnly: false,
        includeHalfChecked: false,
      });
      console.log(list);
      let arr = [];
      this.actions.forEach((item) => {
        // arr.push(item.id);
        if (item.children) {
          arr.push(item.id);
        }
      });
      this.ruleForm.actions = [...new Set(arr)];
      console.log(this.ruleForm.actions);
      this.axios
        .post("/admin/role/addRole", this.ruleForm)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.mesg,
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.$message({
              message: res.data.mesg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: "保存失败",
            type: "error",
          });
        });
    },

    // 获取所有列表
    getData() {
      this.axios.get("/admin/action/selectActionList2", {}).then((res) => {
        console.log(res);
        this.data = res.data.data;
      });
    },
    handleNodeClick(data, ss, indeterminate) {
      // console.log(data, ss, indeterminate);
      console.log(ss.checkedNodes);
      this.actions = ss.checkedNodes;
      // console.log(this.$refs.tree.getCheckedNodes(true, true));
      console.log(this.$refs.tree.getNode());
    },

    //   返回上一页面
    getBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.textAnnotation {
  margin-left: 40px;
  p {
    margin: 0px;
    font-size: 14px;
    color: #606266;
    font-weight: bold;
    span {
      font-size: 12px;
      color: #ff0000;
    }
  }
}
.jueSe {
  p {
    font-weight: bold;
    color: #409eff;
  }
}
</style>
